import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { ServiceCategory } from 'src/app/models';
import { ServiceCategoryService } from 'src/app/services';
import { AlertService } from 'src/app/utilities/alert.service';
import { NavigationExtras, Router } from '@angular/router';
import { LoadingController, ModalController } from '@ionic/angular';
@Component({
  selector: 'app-all-stylist-service-add-category',
  templateUrl: './all-stylist-service-add-category.page.html',
  styleUrls: ['./all-stylist-service-add-category.page.scss'],
})
export class AllStylistServiceAddCategoryPage implements OnInit {
  public serviceCategoryForm: UntypedFormGroup;
  public serviceCategoryField: UntypedFormControl;

  public serviceCategory: ServiceCategory = new ServiceCategory({
    id: 0,
    categoryName: null,
    serviceDefinitions: null,
  });

  constructor(
    private alertService: AlertService,
    private formBuilder: UntypedFormBuilder,
    private router: Router,
    private modalCtrl: ModalController,
    private loadingCtrl: LoadingController,



    private serviceCategoryService: ServiceCategoryService,
  ) { }

  ngOnInit() {
    this.serviceCategoryField = new UntypedFormControl('');
    this.serviceCategoryForm = this.formBuilder.group({
      serviceCategory: this.serviceCategoryField
    });
  }
  public onCancel() {
    this.modalCtrl.dismiss();

  }

  public async onSaveCategory() {
    if (!this.serviceCategoryForm.valid) {
      return;
    }
    const loader = await this.loadingCtrl.create({
      spinner: 'crescent',
    });

    loader.present();
    this.serviceCategory = this.serviceCategory.setCategoryName(this.serviceCategoryField.value);
    try {
      const res = await this.serviceCategoryService.saveServiceCategory(this.serviceCategory);
      loader.dismiss().then(() => {
        this.modalCtrl.dismiss(res);
      });
    }
    catch (err) {
      this.alertService.presentErrorAlert();
    } 
  }

}
